import { RootState } from '..';

export const selectDefinitions = (state: RootState) => state.bucket.definitions;
export const selectDefinitionOptions = (definitionId: string) => (state: RootState) =>
  state.bucket.definitions.find((definition) => definition.definitionId === definitionId)?.options;
export const selectDefinitionRanges = (definitionId: string) => (state: RootState) =>
  state.bucket.definitions.find((definition) => definition.definitionId === definitionId)?.ranges;
export const selectWeight = (state: RootState) => state.bucket.weight;
